import { render, staticRenderFns } from "./PageFaqSection.vue?vue&type=template&id=15a20c16&scoped=true"
import script from "./PageFaqSection.vue?vue&type=script&lang=ts"
export * from "./PageFaqSection.vue?vue&type=script&lang=ts"
import style0 from "./PageFaqSection.vue?vue&type=style&index=0&id=15a20c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a20c16",
  null
  
)

export default component.exports